export enum BlockedBy {
  CrmHardBlock = 4,
  CrmSoftBlock = 8,
  MyTelecomHardBlock = 16,
}
